const RowSelectionCell = ({ row }) => {
  return (
    <input
      type="checkbox"
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onClick={(e) => e.stopPropagation()}
      onChange={row.getToggleSelectedHandler()}
    />
  )
}

export default RowSelectionCell
